import React from "react";
import { Link } from "react-scroll";

// import img
import Image from "../assets/img/Aboutimg.png";
import { navigation } from "./../data";

const About = () => {
  console.log(navigation[3].href, "nav");
  return (
    <section className="section bg-black" id="about">
      <div className="container mx-auto">
        <div className="flex flex-col xl:flex-row gap-24">
          <img
            style={{ margin: "auto" }}
            className="object-cover h-full w-[500px] md:mx-auto lg:mx-0 rounded-2xl"
            src={Image}
            alt=""
          />
          <div className="flex flex-col items-center text-center lg:items-start lg:text-left">
            <div className="flex flex-col">
              <h2 className="text-3xl lg:text-4xl font-medium lg:font-extrabold mb-3 before:content-about relative before:absolute before:opacity-40 before:-top-[2rem] before:hidden before:lg:block">
                Sandeep
              </h2>
              <p className="mb-4 text-accent">FullStack - Web Developer</p>
              <hr className="mb-8 opacity-5" />

              <h1>Hello, I'm Sandeep!</h1>
              <p>
                Based in Delhi, India, I'm a MERN STACK developer with hands-on
                project experience. I specialize in building websites and web
                applications that impress and enhance lives.
              </p>
              <p>
                My expertise extends from working with individuals and small
                businesses to large enterprise corporations. As a developer, I
                write and style both front-end and back-end components, ensuring
                they meet mockup requirements and fulfill user stories.
              </p>
              {/* Add other sections of your portfolio here */}
            </div>
            {/* <a href={navigation[3].href}  >
           <button className='btn btn-md bg-accent hover:bg-secondary-hover transition-all'>
              Contact me
            </button>
           </a> */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
